import { SourceStatus, SourceType } from "@gx/ts-contracts/services/database/models/public_pb";
import {
  CreateProjectRequest,
  CreateProjectSourcesRequest,
  UpdateProjectRequest,
} from "@gx/ts-contracts/services/ontology/api/project_pb";
import { ProjectMappingMethod } from "@gx/ts-contracts/services/project/resources/project_configuration/project_configuration_pb";

export enum CreateProjectFormStep {
  CONFIGURE_PROJECT = "CONFIGURE_PROJECT",
  SELECT_PROJECT_SOURCES = "SELECT_PROJECT_SOURCES",
  SELECT_MAPPING_METHOD = "SELECT_MAPPING_METHOD",
}

export interface CreateProjectFormNavigation {
  currentStepIndex: number;
  totalSteps: number;
  isFirstStep: boolean;
  isLastStep: boolean;
  canGoBack: boolean;
  canGoForward: boolean;
}

export interface CreateProjectFormState {
  /**
   * What is the current search query?
   */
  search: string;

  /**
   * What's the current step in the project creation flow?
   */
  step: CreateProjectFormStep;

  /**
   * What's the navigation state for the project creation flow?
   */
  navigation: CreateProjectFormNavigation;

  /**
   * What's the loading state for the project creation flow?
   */
  isLoading: boolean;

  /**
   * Did the update project succeed?
   */
  isUpdateProjectSucceeded: boolean;

  /**
   * Should the error messages be shown?
   */
  shouldShowErrors: boolean;

  /**
   * What are the current form validation errors?
   */
  // errors: CreateProjectFormError[];

  /**
   * The create project request for the new project creation form
   */
  createProjectRequest: CreateProjectRequest;

  /**
   * The update project request for the project update form
   */
  updateProjectRequest: UpdateProjectRequest;

  /**
   * The create project sources request for the project sources selection form
   */
  createProjectSourcesRequest: CreateProjectSourcesRequest;

  /**
   * What source types are selected for filtering sources?
   */
  selectedSourceTypes: SourceType[];

  /**
   * What statuses are selected for filtering sources?
   */
  selectedStatuses: SourceStatus[];

  /**
   * Which mapping method is currently selected?
   */
  selectedMappingMethod: ProjectMappingMethod;

  /**
   * Optional prompt text for auto-introspect mapping method
   */
  autoIntrospectPrompt: string;

  /**
   * Optional cron expression for scheduled project syncs
   */
  projectSyncCronExpression: string;
}
